import { theme as tlTheme } from '@time-line/components/theme';
import merge from 'lodash/merge';

export const websiteTheme = {
  styles: {
    global: {
      ':root': {
        /* NOTE: 0px is just the initial value, we measure the actual height at
         * runtime in components/Header/Header.tsx */
        '--header-height': '0px',
        '--header-offset': 'var(--header-height)',
        '--header-transition': '.2s ease-in-out',
      },
      body: {
        color: 'gray.600',
        bgColor: 'gray.50',
        fontFamily: 'body',
      },
      cite: {
        fontStyle: 'normal',
      },
      strong: {
        fontWeight: 'medium',
      },
      '.js-focus-visible :focus:not([data-focus-visible-added])': {
        outline: 'none',
        boxShadow: 'none',
      },
      '.headroom--scrolled': {
        boxShadow: `0 1px 0 0 ${tlTheme.colors.blackAlpha[300]}`,
      },
      '.round': {
        borderRadius: 'base',
      },
      '#hbl-live-chat-wrapper': {
        position: 'relative',
        zIndex: 'popover',
      },
      '#gorgias-chat-container #chat-button': {
        zIndex: 'docked',
      },
      '#chakra-toast-manager-bottom': {
        bottom: ['0 !important', null, 'm !important'],
      },
      '.chakra-toast__inner': {
        m: '0 !important',
        width: '100%',
        minW: ['100% !important', null, '320px !important'],
        maxW: '360px !important',
      },
      '.chakra-toast + .chakra-toast': {
        mt: ['0', null, '5xs !important'],
      },
    },
  },
};

export const baseTheme = merge({}, tlTheme, websiteTheme);

export const theme = baseTheme;
